module.exports = __webpack_public_path__ + "img/bg-image.784aaeda.png";